const NAVIGATION_EVENT = "xphub:navigation-change";
let installed = false;

function dispatchNavigationEvent() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(NAVIGATION_EVENT, {
      detail: {
        pathname: window.location.pathname || "/",
        search: window.location.search || "",
      },
    })
  );
}

export function installNavigationEvents() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  const wrapMethod = (methodName) => {
    const original = window.history[methodName];
    if (typeof original !== "function") return;

    window.history[methodName] = function wrappedHistoryMethod(...args) {
      const result = original.apply(this, args);
      dispatchNavigationEvent();
      return result;
    };
  };

  wrapMethod("pushState");
  wrapMethod("replaceState");

  window.addEventListener("popstate", dispatchNavigationEvent);
  window.addEventListener("hashchange", dispatchNavigationEvent);
}

export function getCurrentPathname() {
  if (typeof window === "undefined") return "/";
  return window.location.pathname || "/";
}

export function onNavigationChange(handler) {
  if (typeof window === "undefined" || typeof handler !== "function") {
    return () => {};
  }

  const listener = (event) => {
    const nextPath = event?.detail?.pathname || getCurrentPathname();
    handler(nextPath);
  };

  window.addEventListener(NAVIGATION_EVENT, listener);
  return () => window.removeEventListener(NAVIGATION_EVENT, listener);
}
